import { Component, OnDestroy, OnInit } from '@angular/core';
import { faCheckCircle, faEnvelope, faGlobe, faPlayCircle } from '@fortawesome/pro-light-svg-icons';
import { AcModel } from 'projects/runner/src/app/models/ac.model';
import { AuthStateService } from 'projects/runner/src/app/services/auth-state.service';
import { DataService } from 'projects/runner/src/app/services/data.service';
import { TimezoneService } from 'projects/runner/src/app/services/timezone.service';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-date-container',
  templateUrl: './date-container.component.html',
  styleUrls: ['./date-container.component.scss']
})
export class DateContainerComponent implements OnInit, OnDestroy {

  public ac: AcModel = null;
  private acSubscription: Subscription = null;

  public faPlayCircle = faPlayCircle;
  public faCheckCircle = faCheckCircle;
  public faGlobe = faGlobe;
  public faEnvelope = faEnvelope;

  constructor(
    private data: DataService,
    public timezone: TimezoneService,
    public auth: AuthStateService
  ) { }

  ngOnInit(): void {
    this.acSubscription = this.data.ac$.subscribe({
      next: (ac: AcModel) => {
        if (ac !== null) {
          this.ac = ac;
        }
      }
    });
  }

  ngOnDestroy(): void {
    if (this.acSubscription !== null) {
      this.acSubscription.unsubscribe();
    }
  }

}
